import { render, staticRenderFns } from "./ReplyForm.vue?vue&type=template&id=5f76863d&scoped=true"
import script from "./ReplyForm.vue?vue&type=script&lang=ts"
export * from "./ReplyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f76863d",
  null
  
)

export default component.exports